<!--
 Program: UserListPopup.vue
 Author: SDL
 Description: A pop-up screen that queries the user's information and sends the selected user's information.
-->
<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <!-- contents -->
      <div class="modal_header">
        <h5>{{ $t('sdl.user.label.heading') }} {{ $t('sdl.common.label.search') }}
          <span style="color: #ec6934; font-size:14px; padding-top: 1px" v-if="selectedDivisionLabel">&nbsp;{{ $t('cop.user-search.list-of-division',[selectedDivisionLabel]) }}</span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <!-- SEARCH Area -->
        <div class="fx_search_wrap">
          <div class="item_wrap">
            <!-- row1 -->
            <div class="fx_row">
              <div class="item">
                <label>{{ $t('sdl.user.label.userCondition') }}</label>
                <div class="fx_form">
                  <select v-model="searchParam.searchColumn" class="fx_none" style="width:200px" v-if="adSearch || knoxSearch">
                    <option :value="userType.code" v-for="userType in userTypeList" :key="userType.codeId">{{
                      getLabel(userType)
                    }}</option>
                  </select>
                  <input
                    type="text"
                    v-model="searchParam.searchTxt"
                    @keyup.enter.stop="getUserList()"
                    @keyup.esc="searchParam.searchTxt = ''"
                    :placeholder="!(adSearch || knoxSearch) ? $t('cop.common.username-search.place-holder') : ''"
                  />
                  <v-popover trigger="hover" v-if="!knoxSearch" >
                    <button  type="button" class="btn btn_icon ico_tooltip" />
                    <template slot="popover">
                      <UserNameSearchGuideTooltip/>
                    </template>
                  </v-popover>
                </div>
              </div>
            </div>
            <template v-if="userStatus">
            <div class="fx_row">
              <div class="item">
                <label>{{ $t('sdl.user.label.userStatus') }}</label>
                <select class="custom-select" v-model="searchParam.searchStatus">
                  <option :value="userStat.code" v-for="userStat in userStatList" :key="userStat.codeId">{{
                    getLabel(userStat)
                  }}</option>
                </select>
              </div>
            </div>
            </template>
          </div>
          <div class="fx_button">
            <button class="btn btn-search" type="submit" @click="getUserList()">
              {{ $t('sdl.common.label.search') }}
            </button>
          </div>
        </div>
        <div class="list_wrap">
          <div class="com_head">
            <div class="total">
              <strong>{{ total }}</strong>
              <span v-if="!singleMode" style="margin-left:10px;color:#545DD4">{{ selectedUser.length + ' item(s) selected' }}</span>
            </div>
            <div class="button" v-if="selectedDivisionLabel">
              <span class="description">{{ $t('cop.user-search.add-division-guidance')}}</span>
            </div>
          </div>
          <div class="scop_grid">
            <table v-column-resize="resizeColumn">
              <colgroup>
                <col width="50px" v-if="!singleMode">
                <col width="150px">
                <col width="300px">
                <col >
                <col width="160px">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" v-if="!singleMode">
                    <input type="checkbox" @click.stop v-model="selectAll" @change="toggleSelectAll" />
                  </th>
                  <th scope="col">{{ adSearch ? 'AD_USER_ID' : $t('sdl.user.label.knoxId') }}</th>
                  <th scope="col">{{ $t('sdl.common.label.userName') }}</th>
                  <th scope="col">{{ $t('sdl.user.label.deptName') }}</th>
                  <th scope="col">{{ $t('sdl.user.label.mobile') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="userList.length > 0">
                  <tr v-for="(user, index) in userList" :key="index" @dblclick="singleMode ? rtnData(user) : null" :class="singleMode ? 'cursor-pointer' : ''">
                    <td v-if="!singleMode" class="tc">
                      <input type="checkbox" v-if="adSearch" v-model="user.selected" @change="selectRow(user)" :disabled="dotIdYn == 'D' && user.cn.indexOf('.id') > -1 " />
                      <input type="checkbox" v-else v-model="user.selected" @change="selectRow(user)" :disabled="dotIdYn == 'D' && user.userId.substring(user.userId.length - 3) == '.id'" />
                    </td>
                    <td class="tl" :title="adSearch ? user.cn : user.knoxId">{{ adSearch ? user.cn : user.knoxId }}</td>
                    <td class="tl" :title="adSearch ? user.description : user.userName">{{ adSearch ? user.description : user.userName }}</td>
                    <td class="tl" :title="adSearch ? user.department : user.deptName">{{ adSearch ? user.department : user.deptName }}</td>
                    <td :title="adSearch ? user.mobilePhone :user.mobile">{{ adSearch ? user.mobilePhone :user.mobile }}</td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td :colspan="!singleMode ? 5 : 4">{{ $t('sdl.common.message.noResult')}}</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <!-- TABLE Area-->
            <!-- Pagination Area-->
            <sdl-pagination
              :current-page="current_page"
              :total-rows="total"
              :per-page="per_page"
              @change="handleCurrentChange"
            />
            <!-- Pagination Area-->
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.cancel') }}
        </button>
        <button v-if="!singleMode" type="button" class="btn btn-primary" @click="rtnData">{{ $t('sdl.common.label.confirm') }}</button>
      </div>
      <!-- // contents -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {RequestUtil, SDLUtil, StringUtil} from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';
import { mapGetters } from 'vuex';
import UserNameSearchGuideTooltip from '@/components/common/tooltip/UserNameSearchGuideTooltip.vue';
import _ from "lodash";

export default {
  components: {
    UserNameSearchGuideTooltip,
  },
  data() {
    return {
      searchParam: {
        searchColumn: '',
        searchTxt: '',
        searchStatus: '',
        active: '',
      },
      selectAll: false,
      per_page: null,
      current_page: null,
      total: null,
      userTypeList: [],
      userStatList: [],
      userList: [],
      selectUser: [],
      selectedUser: [],
      checkUserId: '',
      regExp: {
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      },
    };
  },
  props: {
    searchColumn: {
      required: false,
      type: String,
    },
    searchTxt: {
      required: false,
      type: String,
    },
    userStatus: {
      required: false,
      type: Boolean,
    },
    knoxSearch: {
      required: false,
      type: Boolean,
    },
    adSearch: {
      required: false,
      type: Boolean,
    },
    dotIdYn: {
      required: false,
      type: String,
    },
    divisionCd: {
      required: false,
      type: String,
      default: '',
    },
    singleMode: {
      required: false,
      type: Boolean,
    },
    rtnFunc: {
      type: Function,
    },
    admin: {
      type: Boolean,
    },
    searchLocale: {
      type: String,
    },
  },
  mixins: [SDLLocale],
  methods: {
    /**
     * param: object
     * return: nothing
     * exception: nothing
     * description: User Lookup List Checkbox Click
     */
    selectRow(item) {
      const index = this.selectedUser.findIndex(v => v.userId === item.userId);
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        if (index > -1) this.selectedUser.splice(index, 1);
      } else {
        if (index < 0) this.selectedUser.push(item);
      }
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Select All
     */
    toggleSelectAll() {
      this.userList.forEach(user => {
        if (!(this.dotIdYn === 'D' && user.userId.substring(user.userId.length - 3) === '.id')) {
          user.selected = this.selectAll;
          this.selectRow(user);
        }
      });
    },
    /**
     * param: number
     * return: nothing
     * exception: Call error alert
     * description: User Lookup
     */
    getUserList(pageIndex = 1) {
      /**
       * Query value must be entered when querying knox
       */
      if (this.knoxSearch) {
        if (this.searchParam.searchTxt === undefined || this.searchParam.searchTxt === '') {
          SDLUtil.alert('sdl.popup.message.enterRequired');
          return;
        }

        if (
          this.searchParam.searchColumn === 'userName'
          && (this.getByte(this.searchParam.searchTxt) > 0 && this.getByte(this.searchParam.searchTxt) < 4)
        ) {
          SDLUtil.alert('sdl.popup.message.enterMore4Byte');
          return;
        }

        if (this.searchParam.searchColumn === 'email' && !this.regExp.email.test(this.searchParam.searchTxt)) {
          SDLUtil.alert('sdl.samsung.validate.email');
          return;
        }
      }

      if (this.searchParam.searchTxt !== 'email' && this.knoxSearch) {
        if (this.checkSearchText() !== true) return;
      }

      // Set the page number sent to the current page number
      this.current_page = pageIndex;

      // Launch Loading bar
      SDLUtil.showLoadingBar(true);

      /**
       * Activate user selection when present
       */
      if (this.userStatus) {
        if (this.searchParam.searchStatus === 'ALL') {
          this.searchParam.active = '';
        } else {
          this.searchParam.active = this.searchParam.searchStatus;
        }
      }

      let apiUrl = '';

      /**
       * Set user lookup API enforcement parameter
       */
      let active = null;
      if (this.searchParam.active === 'ACTIVE') active = 0;
      if (this.searchParam.active === 'INACTIVE') active = 1;
      if (this.searchParam.active === 'WAITING') active = 2;
      if (this.searchParam.active === 'DELETED') active = 3;
      const params = {
        searchCondition: this.searchParam.searchColumn,
        searchKeyword: this.searchParam.searchTxt,
        active,
        pageIndex: this.current_page,
        pageSize: this.per_page,
        dotIdYn: this.dotIdYn,
        divisionCd: this.divisionCd,
        locale: this.searchLocale ? this.searchLocale : this.locale,
      };

      /**
       * User lookup API address branching out and applying
       */
      if (this.knoxSearch) {
        apiUrl = `${SDLUtil.API_URL}/auth/users/ldap`;
      } else if (this.adSearch) {
        if (this.admin) apiUrl = `${SDLUtil.API_URL}/user/ad-db-users/admin`;
        else apiUrl = `${SDLUtil.API_URL}/user/ad-db-users`;
      } else {
        if (this.admin) apiUrl = `${SDLUtil.API_URL}/user/db-users/admin`;
        else apiUrl = `${SDLUtil.API_URL}/user/db-users`;
      }

      /**
       * Call user lookup API
       */
      axios
        .post(apiUrl, params)
        .then(({ data }) => {
          this.userList = data.rows;
          // Apply the page number that was retrieved to the current_page
          this.current_page = data.currentPage;
          // Full Row Count
          this.total = data.records;

          this.userList.forEach(user => {
            if (this.knoxSearch && this.locale !== 'ko_KR') {
              user.userName = user.userNameEn
              user.grdName = user.grdNameEn
              user.deptName = user.deptNameEn
              user.compName = user.compNameEn
            }
            if (!this.singleMode) {
              if (this.selectedUser.findIndex(v => v.userId === user.userId) > -1) {
                user.selected = true;
              }
            }
          });

          /**
           * If the paging result is 1 and the query result is one, return and close
           */
          if (this.userList.length === 1 && this.current_page === 1) {
            this.rtnFunc(this.userList);
            this.$emit('close');
          }

          // Remove Loading bar
          SDLUtil.showLoadingBar(false);
        })
        .catch(err => {
          // Remove Loading bar
          SDLUtil.showLoadingBar(false);
          // Call error alert
          if(err.data.error && err.data.error.reason) {
            SDLUtil.alert({
              msg: err.data.error.reason,
              onOkEvt: () => {
                this.$emit('close');
              },
            });
          }
        });

      // Unselect All
      this.selectAll = false;
    },
    /**
     * param: string
     * return: number
     * exception: nothing
     * description: Return string byte length
     */
    getByte(str) {
      return str
        .split('')
        .map(s => s.charCodeAt(0))
        // eslint-disable-next-line no-bitwise,no-nested-ternary
        .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
    },
    /**
     * param: number
     * return: nothing
     * exception: nothing
     * description: paging
     */
    handleCurrentChange(currentPage) {
      // Invoke user lookup method
      this.getUserList(currentPage);
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Calling up functions that send selected user information to the screen from which it was recalled
     */
    rtnData(user) {
      let selectUser = [];

      /**
       * Apply outgoing values by branching out if they are applied on a quarterly basis
       */
      if (this.singleMode) selectUser.push(user);
      else selectUser = this.selectedUser;

      this.rtnFunc(selectUser);
      this.$emit('close');
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Replace special characters to spaces
     */
    checkSearchText() {
      const specialPattern = /[`~!@#$%^&*|\\\'\";:\/?]/gi;
      if (specialPattern.test(this.searchParam.searchTxt) === true) {
        SDLUtil.alert('cop.common.message.special-character');
        return false;
      }
      return true;
    },
    async getDivisionCodeList() {
      await this.$store.dispatch('USER_DIV_INFO', {}).then(() => {
      });
    },
  },
  created() {
    // Page size - 10 settings
    this.per_page = 10;

    let commonGrpCode = 'USER_SEARCH_TYPE_S';

    if (this.knoxSearch) {
      commonGrpCode = 'USER_SEARCH_TYPE_K';
    }

    if (this.adSearch) {
      commonGrpCode = 'USER_SEARCH_TYPE_A';
    }

    // user query condition type common code
    axios.get(`${SDLUtil.API_URL}/commcode/groupcodes/${commonGrpCode}/commcodes`).then(({ data }) => {
      this.userTypeList = data;
    });

    // user status common code
    axios.get(`${SDLUtil.API_URL}/commcode/groupcodes/USER_STAT/commcodes`).then(({ data }) => {
      this.userStatList = data;
    });

    /**
     * Query condition setting
     */
    if (this.searchColumn === null || this.searchColumn === undefined) {
      this.searchParam.searchColumn = 'userName';
    } else {
      this.searchParam.searchColumn = this.searchColumn;
    }

    if (this.searchTxt !== null && this.searchTxt !== undefined) {
      this.searchParam.searchTxt = this.searchTxt;
    }

    /**
     * Applying exceptional conditions of inquiry to Knox inquiry
     */
    if (this.knoxSearch) {
      if (this.searchTxt === null || this.searchTxt === undefined) {
        return;
      }
      if (this.searchParam.searchColumn === 'userName' && this.searchParam.searchTxt.length < 2) {
        return;
      }
    }

    // Apply Default Value When User Status Existence
    if (this.userStatus) {
      this.searchParam.searchStatus = 'ALL';
    }

    // If there is no param value to select only one user, apply multiple selections
    if (this.singleMode === undefined) {
      this.singleMode = false;
    }

    /**
     * Apply to lookup only if there is a lookup value when inquiring knox
     */
    if (this.knoxSearch) {
      if (this.searchParam.searchTxt) {
        this.getUserList();
      }
    } else {
      this.getUserList();
    }
    this.getDivisionCodeList();
  },
  computed: {
    ...mapGetters({ locale: 'getLocale', divisionCodeList: 'getDivisionInfo' }),
    selectedDivisionLabel() {
      const selectedDivision = _.find(this.divisionCodeList, { divisionCd: this.divisionCd });
      return _.isEmpty(selectedDivision) ? '' : selectedDivision.label;
    },
    resizeColumn() {
      let columnLength = !this.singleMode ? 5 : 4;
      let cols = '';
      for (let i = 0; i < columnLength; i += 1) {
        if (i !== 0) cols += ',';
        cols += i;
      }
      return cols;
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/popup/UserListPopup.vue